export function useDeliveryLocations() {
  var selectedDeliveryLocation = useState('selected-delivery-location', function () {
    return null;
  });
  function setSelectedDeliveryLocation(location) {
    selectedDeliveryLocation.value = location !== null && location !== void 0 ? location : null;
  }
  return {
    selectedDeliveryLocation: readonly(selectedDeliveryLocation),
    setSelectedDeliveryLocation: setSelectedDeliveryLocation
  };
}